import { render, staticRenderFns } from "./paginateTable.vue?vue&type=template&id=70b6e224"
import script from "./paginateTable.vue?vue&type=script&lang=js"
export * from "./paginateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports